import React from 'react';

import Select from '../../../../library/select/select';
import FitMessage from '../../../../components/fit-message/fit-message.one-dt';
import FilterButton from '../filter-button/filter-button';

import { Fitment } from '../../../../shared/types/fitment';
import {
  DoesFitEnum,
  ProductTypeEnum
} from '../../../../shared/types/graphql-types';
import { FIT } from '../../../../shared/constants/fit';
import { PRODUCT_TYPES } from '../../../../shared/constants/products';

import './results-bar.scss';

interface ResultsBarProps {
  currentSort: string;
  doesFitEnum: DoesFitEnum;
  filterCount: number;
  infoMessage?: { id: number };
  isLoading: boolean;
  isPackage: boolean;
  onSelectSort: (data) => void;
  onToggleMobileFilter: () => void;
  productType: ProductTypeEnum;
  resultsText: string;
  selectedFitment: Fitment;
  showCount: boolean;
  showFilter: boolean;
  showFitmentMsg?: boolean;
  sorts: string[];
  totalNumberOfResults: string | number;
}

const ResultsBar = React.forwardRef<HTMLDivElement, ResultsBarProps>(
  function ResultsBar(props, ref) {
    const {
      currentSort,
      doesFitEnum,
      filterCount,
      infoMessage,
      isLoading = false,
      isPackage = false,
      onSelectSort,
      onToggleMobileFilter,
      productType,
      resultsText,
      selectedFitment,
      showCount = false,
      showFilter = false,
      showFitmentMsg = false,
      sorts,
      totalNumberOfResults
    } = props;

    let sortOptions;
    if (sorts && typeof sorts === 'object' && Object.keys(sorts).length > 0) {
      sortOptions = Object.keys(sorts).map(sort => sorts[sort]);
    }

    return (
      <div
        className="results-bar"
        ref={ref}
        styleName={`${
          !showFitmentMsg ? 'container' : 'container-without-fit-msg'
        } ${productType === PRODUCT_TYPES.TIRES ? 'container--no-border' : ''}`}
      >
        {showFilter && (
          <FilterButton
            filterCount={filterCount}
            onToggleMobileFilter={onToggleMobileFilter}
          />
        )}

        {showCount && (
          <div className="results-bar__count-line" styleName="count-line">
            <strong>{totalNumberOfResults || 0}</strong> {resultsText || ''}
          </div>
        )}

        {!showFitmentMsg && (
          <FitMessage
            data-testid="FitMessage"
            doesFit={doesFitEnum === FIT}
            fitment={selectedFitment}
            infoMessage={infoMessage}
            isLoading={isLoading}
            isPackage={isPackage}
            productType={productType}
          />
        )}

        {currentSort && sorts?.[currentSort] && (
          <div
            className="results-bar__select-wrapper"
            styleName="select-wrapper"
          >
            <Select
              data-testid="plp-results-sort"
              label="Sort"
              onChange={data => onSelectSort(data)}
              options={sortOptions}
              value={sorts[currentSort]}
            />
          </div>
        )}
      </div>
    );
  }
);
export default ResultsBar;
